import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Icon } from "@/lib/icons";

export default function MyTasks() {
  const [tasks, setTasks] = useState([]);
  const [showDone, setShowDone] = useState(false);
  const load = useCallback(async () => { const r = await api.get("/board-tasks"); setTasks(r.data.tasks); }, []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (t) => { await api.post(`/board-tasks/${t.task_id}/toggle`); load(); };
  // Default to OPEN tasks only (matches the dashboard header count); completed are reachable via the toggle.
  const doneCount = tasks.filter((t) => t.done).length;
  const visible = showDone ? tasks : tasks.filter((t) => !t.done);

  return (
    <div data-testid="my-tasks-page">
      <h1 className="font-zilla text-3xl sm:text-4xl font-semibold mb-1">My Tasks</h1>
      <p className="text-[16px] text-ink/70 mb-5">Action items assigned to you — from meeting minutes or directly.</p>
      {doneCount > 0 && (
        <button data-testid="toggle-completed" onClick={() => setShowDone((s) => !s)}
          className="mb-3 text-[14px] font-semibold text-dark-olive hover:text-ink inline-flex items-center gap-1.5">
          <Icon name={showDone ? "EyeOff" : "Eye"} className="w-4 h-4" />
          {showDone ? "Hide completed" : `Show completed (${doneCount})`}
        </button>
      )}
      <div className="bg-cream border border-ink/15 rounded-xl overflow-hidden">
        {visible.length === 0 && <div className="p-10 text-center text-ink/55">{showDone ? "No tasks assigned to you." : "No open tasks \u2014 you're all caught up."}</div>}
        {visible.map((t) => (
          <div key={t.task_id} data-testid={`task-${t.task_id}`} className="flex items-center gap-3 px-5 py-4 border-b border-ink/8 last:border-0">
            <button data-testid={`task-toggle-${t.task_id}`} onClick={() => toggle(t)} className={`w-5 h-5 rounded border flex items-center justify-center shrink-0 ${t.done ? "bg-olive border-olive text-cream" : "border-ink/30"}`}>{t.done && <Icon name="Check" className="w-3.5 h-3.5" />}</button>
            <div className="min-w-0 flex-1">
              <div className={`text-[15px] ${t.done ? "line-through text-ink/40" : ""}`}>{t.title}</div>
              <div className="text-[12px] text-ink/50">{t.source === "minutes" ? "From a board meeting" : "Directly assigned"}{t.progress && t.progress.total > 1 ? ` · ${t.progress.done} of ${t.progress.total} done` : ""}</div>
            </div>
            {t.meeting_id && <span className="text-[12px] px-2.5 py-1 rounded-full bg-olive/15 border border-olive/30 shrink-0" data-testid={`task-meeting-${t.task_id}`}>Meeting</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
